import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const OperatorSekeltonProfile = () => {
  return (
    <>
      <section className="touroprator_section bg-white pt-4">
        <Container fluid>
          <Row className="justify-content-center">
            <Col xxl={8} xl={10} lg={12}>
              <div className="top_opratorsBox logedin p-3 border rounded">
                <Row className="gx-lg-2">
                  <Col lg={3} md={4}>
                    <div className="tourLogoes">
                      <div className="images_tour">
                        <Skeleton height={152} width={282} />
                      </div>
                      <div className="d-flex justify-content-around mt-4">
                        <Skeleton width={280} height={55}/>
                      </div>
                    </div>
                  </Col>
                  <Col lg={9} md={8} className="pt-3 pt-md-0">
                    <div className="provider_details ps-lg-3">
                      <div className="title_tours d-flex justify-content-between align-items-center gap-md-2 gap-xxl-3">
                        <Skeleton width={146} height={"100%"} />

                        <div className="follow_massage d-flex gap-3">
                          <div className="follow mb-lg-2 mb-xxl-0 mb-2">
                            <Skeleton
                              width={110}
                              height={36}
                              className="rounded-pill"
                            />
                          </div>
                          <div className="message">
                            <Skeleton
                              width={130}
                              height={36}
                              className="rounded-pill"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="title_tours">
                        <Skeleton width={188} height={13} />
                      </div>
                      <div className="providerNamerating tours d-flex flex-wrap gap-4 align-items-center pb-3 pt-1">
                        <Skeleton width={400} height={13} />
                      </div>
                      <div className="detailsText pb-3">
                        {/* <Skeleton /> */}
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default OperatorSekeltonProfile;
